module.exports = __webpack_public_path__ + "static/img/6@2x.51107b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/6@2x.png
// module id = ESL0
// module chunks = 1